import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Config } from '@ionic/angular';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { formatText } from 'src/app/shared/commen-function-file';

@Component({
  selector: 'app-lnd-dashboard-detail',
  templateUrl: './lnd-dashboard-detail.component.html',
  styleUrls: ['./lnd-dashboard-detail.component.scss'],
})
export class LndDashboardDetailComponent  implements OnInit {
loggedInUserId: any;
  moduleName: any;
  nominations: any = [];
  attended: any = [];
  upcomingPrograms: any = [];
  totalMandays:any=[];
  recommndedPrograms:any=[]
  notRecivedAsset: any = []
  isToggleOn: boolean = true;
  type: any = "Recived Asset";
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private httpService: HttpService, private config: Config, private encryptionService: EncryptionService,) {
    console.log(data);
    this.moduleName = data.moduleName;
    this.nominations = data.allApiData;
    this.upcomingPrograms = data.repairedsset;
    this.loggedInUserId = data.loggdingUserId;
    this.attended = data.newAllAssetListingData


  }

  ngOnInit() {
    this.loadDummyData(); 
  }

  loadDummyData() {
    this.nominations = [
      { type:'LMS',title: 'Leadership Program', code: 'PSF001', link: 'www.gmail.com', faculty: 'Mr.Das', objective: 'Increase problem solving skills of member', startDate: '1-10-2024', endDate: '10-10-2024',location:'pune', empNames: ['A', 'B', 'C'] },
      {type:'LMS', title: 'Leadership Program', code: 'PSF001', link: 'www.gmail.com', faculty: 'Mr.Das', objective: 'Increase problem solving skills of member', startDate: '1-10-2024', endDate: '10-10-2024',location:'pune', empNames: ['A', 'B', 'C'] }
      
    ];

    this.attended = [
      {type:'LMS', title: 'Leadership Program', code: 'PSF001', link: 'www.gmail.com', faculty: 'Mr.Das', objective: 'Increase problem solving skills of member', startDate: '1-10-2024', endDate: '10-10-2024',location:'pune', empNames: ['A', 'B', 'C'] },
      {type:'LMS', title: 'Leadership Program', code: 'PSF001', link: 'www.gmail.com', faculty: 'Mr.Das', objective: 'Increase problem solving skills of member', startDate: '1-10-2024', endDate: '10-10-2024', location:'pune',empNames: ['A', 'B', 'C'] }

    ];

    this.upcomingPrograms = [
      {type:'LMS', title: 'Leadership Program', code: 'PSF001', link: 'www.gmail.com', faculty: 'Mr.Das', objective: 'Increase problem solving skills of member', startDate: '1-10-2024', endDate: '10-10-2024', location:'pune',empNames: ['A', 'B', 'C'] },
      { type:'LMS', title: 'Leadership Program', code: 'PSF001', link: 'www.gmail.com', faculty: 'Mr.Das', objective: 'Increase problem solving skills of member', startDate: '1-10-2024', endDate: '10-10-2024',location:'pune', empNames: ['A', 'B', 'C'] }

    ];

    this.totalMandays = [
      { type:'LMS',title: "Problem solving masterclass", startDate: "1-10-2024", endDate: '10-10-2024',mandays:'10' },
      { type:'LMS',title: "Problem solving masterclass", startDate: "1-10-2024", endDate: '10-10-2024',mandays:'10' }
    ];

    this.recommndedPrograms = [
      { title: "Problem solving masterclass",details:'PSF001',brochure:'attachment.doc', startDate: "1-10-2024", endDate: '10-10-2024',comment:'xyz..' },
   
    ];
  }

  

  onChangeSwitch(event: any) {
    this.isToggleOn = event?.checked;
    this.type = event?.checked ? 'Recived Asset' : 'Not Recived Asset';
  }
 



  

}
